import { observer } from 'mobx-react-lite'
import { Link } from 'react-router-dom'
import { useMeta } from '@/shared/lib/hooks/useMeta'
import { SUPPORT_URL } from '@/shared/lib/contacts'
import { useAuth } from '@/stores/RootStore'
import styles from './NotFound.module.css'

/**
 * Страница не найдена.
 *
 * Раньше любой неизвестный адрес молча уводил на `/app`. Для человека,
 * открывшего оборванную ссылку на оплату, это выглядело как «магазин
 * прислал ссылку в личный кабинет чужого сервиса»: ни ошибки,
 * ни объяснения, ни повода написать продавцу. Ссылку на оплату
 * копируют из мессенджеров, и обрывается она регулярно.
 */
export const NotFoundPage = observer(function NotFoundPage() {
  useMeta('Страница не найдена')
  const auth = useAuth()

  return (
    <div className={styles.wrap}>
      <div className={styles.card}>
        <span className={styles.code}>404</span>
        <h1 className={styles.title}>Страница не найдена</h1>

        <div className={styles.actions}>
          <Link className={styles.primary} to={auth.authenticated ? '/app' : '/'}>
            {auth.authenticated ? 'В кабинет' : 'На главную'}
          </Link>
          <a className={styles.ghost} href={SUPPORT_URL}
             target="_blank" rel="noopener noreferrer">Написать в поддержку</a>
        </div>
      </div>
    </div>
  )
})
